import { Link } from 'react-router-dom';
import type { GsStory } from '@/lib/types';
import { formatPublished } from '@/lib/format';
import DemoBadge from '@/components/feature/DemoBadge';

export default function ArticleCard({ story }: { story: GsStory }) {
  return (
    <Link to={`/news/${story.slug}`} className="group flex flex-col bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-foreground-700 transition-colors cursor-pointer">
      <div className="relative w-full h-52 overflow-hidden">
        <img src={story.image} alt={story.title} title={story.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700" />
        {story.is_demo && <div className="absolute top-3 right-3"><DemoBadge label="Sample story" /></div>}
      </div>
      <div className="flex flex-col flex-1 p-5">
        <p className="font-label uppercase tracking-widest text-[11px] font-semibold text-primary-600">{story.category}{story.city ? ` \u00b7 ${story.city}` : ''}</p>
        <h3 className="mt-2 font-heading font-bold text-xl leading-snug text-foreground-950 group-hover:text-primary-600 transition-colors">{story.title}</h3>
        {story.excerpt && <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-3">{story.excerpt}</p>}
        <p className="mt-auto pt-4 font-label uppercase tracking-widest text-[11px] text-foreground-500">
          {story.author || 'GreenSide Newsroom'}{story.published_at ? ` \u00b7 ${formatPublished(story.published_at)}` : ''}
        </p>
      </div>
    </Link>
  );
}